const BlockSelectTypes = {
  OPTION: 'option', // default
  KEYWORD: 'keyword',
  KEYWORD_SINGLE: 'keyword_single',
  KEYWORD_CONDITION: 'keyword_condition',
  TIME: 'time',
};

export default BlockSelectTypes;
